import { render, staticRenderFns } from "./TrStepV2.vue?vue&type=template&id=4b829696&scoped=true&"
import script from "./TrStepV2.vue?vue&type=script&lang=js&"
export * from "./TrStepV2.vue?vue&type=script&lang=js&"
import style0 from "./TrStepV2.vue?vue&type=style&index=0&id=4b829696&lang=scss&scoped=true&"
import style1 from "./TrStepV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b829696",
  null
  
)

export default component.exports